import { render, staticRenderFns } from "./RelatorioLogFaq.vue?vue&type=template&id=922cdbbe&scoped=true"
import script from "./RelatorioLogFaq.vue?vue&type=script&lang=js"
export * from "./RelatorioLogFaq.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogFaq.vue?vue&type=style&index=0&id=922cdbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922cdbbe",
  null
  
)

export default component.exports